import { render, staticRenderFns } from "./copyJcontentDialog.vue?vue&type=template&id=24be71ec"
import script from "./copyJcontentDialog.vue?vue&type=script&lang=js"
export * from "./copyJcontentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports